import { ITruckData, ITruckDetail } from '../interfaces/Truck.interface';
import { extractAndEncode } from '../utils/string';
import { axiosAuthInstance } from './Auth.service';

export const getTrucksList = async (
  limit: number,
  offset: number,
  nextLink?: string,
  country?: string,
  transporterIds?: string[],
  searchQuery?: string
): Promise<ITruckData> => {
  const client = await axiosAuthInstance();
  let queryParams = '';

  if (country !== undefined && country.length > 0) {
    queryParams += `&country_name=${country}`;
  }

  transporterIds?.forEach((filter) => {
    queryParams += `&transporterIds[]=${filter}`;
  });

  if (searchQuery !== undefined && searchQuery.length > 0) {
    queryParams += `&search=${searchQuery}`;
  }

  if (nextLink !== undefined) {
    queryParams += `&nextLink=${extractAndEncode(nextLink)}`;
  }

  const response = await client.get(`/truck/list?limit=${limit}&offset=${offset}${queryParams}`);

  return {
    ...response.data,
    nextLink: response.data.pagination?.nextLink,
  };
};

export const getTruck = async (id: string): Promise<ITruckDetail> => {
  const client = await axiosAuthInstance();
  const response = await client.get(`/truck/${id}`);
  return response.data;
};